import "./LoginPopup.scss";
import useAppDispatch from "../../hooks/useAppDispatch";
import useAppSelector from "../../hooks/useAppSelector";
import {useTranslation} from "react-i18next";
import {Link, useNavigate} from "react-router-dom";
import {closeLoginPopup, openMessage} from "../../store/notification/notificationSlice";
import {Form, Input} from "antd";
import CustomButton from "../UI/CustomButton/CustomButton";
import {ILoginRequest} from "../../models/Auth";
import {AuthService} from "../../services/auth.service";
import {login, logout} from "../../store/profile/profileSlice";
import React, {useState} from "react";
import useDisableScroll from "../../hooks/useDisableScroll";
import LoginGymSelect from "../UI/LoginGymSelect/LoginGymSelect";
import {IMultiGymInfo, setActiveGym} from "../../store/multiGyms/multiGymsSlice";
import {$clientApi} from "../../http";


const LoginPopup = () => {
    useDisableScroll();
    const dispatch = useAppDispatch();
    const {t} = useTranslation();
    const navigate = useNavigate();

    const {isOpen, redirectPath} = useAppSelector(state => state.notificationSlice.loginPopup);
    const {activeGym} = useAppSelector(state => state.multiGymsSlice);

    const [selectedGym, setSelectedGym] = useState<null | IMultiGymInfo>(null);

    const onCancel = () => {
        if (redirectPath) {
            navigate(redirectPath);
        }
        dispatch(closeLoginPopup());
    }

    const makeLogoutBeforeLogin = () => {
        dispatch(logout());
        AuthService.logout();
    }

    const redirectToRegister = () => {
        navigate("/auth/register");
    }

    const onFinish = async (values: ILoginRequest) => {
        values.username = values.email;
        makeLogoutBeforeLogin();
        const gymToLogin = selectedGym ? selectedGym : activeGym;
        try {
            const response = await AuthService.login(values, gymToLogin.endpoint);
            if (response.data.length) {
                AuthService.setTokens({access_token: response.data[0].access_token, refresh_token: response.data[0].refresh_token});

                $clientApi.defaults.baseURL = gymToLogin.endpoint;
                const profileResponse = await AuthService.getProfile();
                if (profileResponse.data) {
                    localStorage.setItem("active_gym_info", JSON.stringify(gymToLogin));
                    dispatch(setActiveGym(gymToLogin));

                    dispatch(login(profileResponse.data));
                    dispatch(openMessage({type: "success", title: t("LoggedIntoYourAccount")}));
                    dispatch(closeLoginPopup());
                } else {
                    $clientApi.defaults.baseURL = activeGym.endpoint;

                    AuthService.logout();
                    dispatch(openMessage({type: "error", title: t("PasswordOrLoginEnteredIncorrectly")}));
                }
            } else {
                dispatch(openMessage({type: "error", title: t("PasswordOrLoginEnteredIncorrectly")}));
            }
        } catch (e: any) {
            if (e.response && e.response.data && e.response.data.message) {
                dispatch(openMessage({type: "error", title: t(e.response.data.message)}));
            } else {
                dispatch(openMessage({type: "error", title: t("PasswordOrLoginEnteredIncorrectly")}));
            }

        }

    }

    return (
        <>
            {isOpen && (<div className={"login-popup-component"}>
                <div className={"login-modal"}>
                    <h2 className={"title"}>{t("Login")}</h2>
                    <Form
                        className={"form"}
                        name="login"
                        onFinish={onFinish}
                    >
                        <Form.Item
                            className={`login-popup__item`}
                            name={"email"}
                            label={t("EmailAddress")}
                            rules={[{required: true}]}
                        >
                            <Input
                                className={"input"}
                            />

                        </Form.Item>


                        <Form.Item
                            className={`login-popup__item`}
                            name={"password"}
                            label={t("Password")}
                            rules={[{required: true}]}
                        >
                            <Input.Password
                                className={"input password"}
                            />

                        </Form.Item>

                        <LoginGymSelect
                            mode={"light"}
                            selectedGym={selectedGym}
                            setSelectedGym={setSelectedGym}
                        />

                        <div className={"link-wrapper"}>
                            <Link
                                className={"link"}
                                to={"/auth/forgot-password"}
                            >
                                {t("ForgotYourPassword")}?
                            </Link>
                        </div>

                        <div className={"bottom"}>

                            <CustomButton
                                text={t("SignIn")}
                                type={"submit"}
                                typeStyle={"fill"}
                                borderRadius={true}
                            />

                            <div className={"divider"}>
                                <div className={"line"}></div>
                                <p className={"text"}>{t("DontHaveAnAccount")}?</p>
                                <div className={"line"}></div>
                            </div>

                            <CustomButton
                                text={t("CreateYourAccount")}
                                type={"button"}
                                typeStyle={"outline"}
                                borderRadius={true}
                                blueForOutline={true}
                                functionOnClick={redirectToRegister}
                            />

                        </div>

                    </Form>
                    <div className={"btn-wrapper"}>
                        <button className={"cancel-btn"} onClick={onCancel}>Cancel</button>
                    </div>

                </div>
            </div>)
            }
        </>
    )
}

export default LoginPopup;